import {Map} from 'immutable';

import GenericExplanation from '../common/V2/GenericExplanation';

import FreeEntryQuestionV2 from './V2/FreeEntryQuestion';
import FreeEntryResponseStats from './V2/FreeEntryQuestionResponseStats';
import FreeEntryEditor from './FreeEntryEditor/FreeEntryEditor';

export const FreeEntryQuestionType = Map({
  type: 'free-entry',
  label: 'Free Entry',
  questionRenderer: FreeEntryQuestionV2,
  explanationRenderer: GenericExplanation,
  responseStatsRenderer: FreeEntryResponseStats,
  editor: FreeEntryEditor,
  isHidden: false
});
